<app-base-quick-view (myEvent)="myEvent.emit()" *ngIf="product" [product]="product" id="app-base-quick-view"></app-base-quick-view>
